import { FunctionComponent } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import classNames from 'classnames';

import classes from './link.module.scss';

export const Link: FunctionComponent<LinkProps> = ({ className, ...props }) => (
  <RouterLink className={classNames(classes.link, className)} {...props} />
);
